<template>
  <div class="widget-header-skeleton">
    <p
      v-if="title"
      class="widget-header-skeleton-title"
    >
      {{ title }}
    </p>
    <v-skeleton-loader
      v-else
      type="text"
      width="140px"
      height="17px"
    />
    <v-icon
      color="iconDefault"
      size="18px"
      icon="$information-outline"
    />
  </div>
</template>

<script>
export default {
  name: 'WidgetHeaderSkeleton',
  props: {
    title: { type: String, default: '' },
  },
};
</script>

<style scoped lang="less">
.widget-header-skeleton {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.widget-header-skeleton-title {
  font-size: 16px !important;
  line-height: 20px;
  color: @text-darkest;
  font-weight: bold !important;
  padding: 0px;
}
</style>
